import { SharedConstants } from "../../../../../../shared/constants/shared.constants";
export class projectCycleFormConstants {
    // form labels
    static NAME_FORM_LABEL = "Name";
    static DESCRIPTION_FORM_LABEL = "Description";
    static COPY_PROJECT_CYCLE_FORM_LABEL = "Copy Project Cycle?";
    static COPY_PROJECT_CYCLE_SELECT_FORM_LABEL = "Project Cycles";
    static FROM_DATE_FORM_LABEL = "From date";
    static TO_DATE_FORM_LABEL = "To date";
    static COMPLETED_FORM_LABEL = "Completed?";
    static PROJECT_DOCUMENTATION_LABEL = "Project documentation";
    // control names
    static NAME_FORM_CONTROL = "name";
    static DESCRIPTION_FORM_CONTROL = "description";
    static COPY_PROJECT_CYCLE_FORM_CONTROL = "copyProjectCycle";
    static COPY_PROJECT_CYCLE_SELECT_FORM_CONTROL = "copyProjectCycleSelect";
    static FROM_DATE_FORM_CONTROL = "fromDate";
    static TO_DATE_FORM_CONTROL = "toDate";
    static COMPLETED_FORM_CONTROL = "completed";
    static PROJECT_DOCUMENTATION_CONTROL = "projectDocumentation";
    // description placeholder
    static ValidationMessage = {
        name: {
            required: `Name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
            maxLength: `Name ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "250")}`
        },
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        selectCopyProjectCycle: {
            required: `Project Cycle ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        fromDate: {
            required: `From date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        toDate: {
            required: `To date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        projectDocumentation: {
            required: `Project document ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
